import * as issueOccurrencePlaces from "./issueOccurrencePlaces";
import i18n from "@/common/lang.serivce";

const IssueOccurrencePlace = {
  list() {
    return Object.keys(issueOccurrencePlaces);
  },
  getAll() {
    return this.list().map(issueOccurrencePlace => {
      return {
        value: issueOccurrencePlace,
        text: i18n.t("occurrencePlaces." + issueOccurrencePlace)
      };
    });
  }
};

export default IssueOccurrencePlace;
